import React, { FC, PropsWithChildren, useMemo, useState } from 'react'
import styles from '../Facets.module.scss'
import SALink from 'components/SALink'
import FormRadio from 'components/SA/FormElements/Radio'
import filterStyles from '../../Filters/Filters.module.scss'
import classNames from 'classnames'

type FilterOptionsObject = {
  text: string
  selected: boolean
  onClick: () => void
  href: string
  isHidden?: boolean
}

type RadioListFacetProps = {
  facetName: string
  filterOptions: ReadonlyArray<FilterOptionsObject>
}

const RadioListFacet: FC<PropsWithChildren<RadioListFacetProps>> = ({
  facetName,
  filterOptions,
  children,
}) => {
  const [isShowMoreOpen, setIsShowMoreOpen] = useState(false)

  const handleToggleShowMore = () => {
    setIsShowMoreOpen((prevValue) => !prevValue)
  }

  const hasHiddenOption = useMemo(() => filterOptions.some(({ isHidden }) => !!isHidden), [
    filterOptions,
  ])

  return (
    <div className={styles.radioListContainer}>
      {!filterOptions.length ? (
        <p className='defaultTypographySmall'>No Options Available</p>
      ) : (
        <div className={filterStyles.listFilterWrapper}>
          <div className={filterStyles.listFilterContainer}>
            {filterOptions.map(({ href, text, onClick, selected, isHidden }) => (
              <SALink
                href={href}
                tabIndex={-1}
                data-gtm-event='filter'
                data-gtm-info={`${facetName} - ${text}`}
                className={classNames(filterStyles.filterItemLink, {
                  [filterStyles.filterItemLinkHidden]: isHidden && !isShowMoreOpen,
                })}
              >
                <FormRadio
                  key={text}
                  name={text}
                  text={text}
                  onClick={onClick}
                  checked={selected}
                  aria-label={`Select ${text}`}
                />
              </SALink>
            ))}
          </div>
          {hasHiddenOption && (
            <div className={filterStyles.collapsableFilterShowMore}>
              <button onClick={handleToggleShowMore}>
                {isShowMoreOpen ? 'Show Less' : 'Show More'}
              </button>
            </div>
          )}

          {children}
        </div>
      )}
    </div>
  )
}

export default RadioListFacet
